<template>
  <div class="srm-time-sign">
    <span v-if="!status||!status.status"></span>
    <a-tooltip v-else overlayClassName="g-table-tooltip" placement="topLeft" :title="status.remark">
      <a-icon v-if="Boolean(status.icon)" :type="status.icon" theme="filled" :class="status.class" />
    </a-tooltip>
  </div>
</template>

<script>
import contrastUtils from '@/public/utils/contrastUtils'
const warningStatus = {
  colourless: { status: 'colourless', remark: "无图标：订单正常" },
  orange: { status: 'orange', elt: 15 * 24 * 60 * 60 * 1000, egt: 6 * 24 * 60 * 60 * 1000, remark: "橙色预警：订单6-15天后到期", class: 'orange', icon: 'exclamation-circle' },
  red: { status: 'red', lt: 6 * 24 * 60 * 60 * 1000, egt: 0, remark: "红色预警：订单0-5天后到期", class: 'red', icon: 'exclamation-circle' },
  black: { status: 'black', lt: 0, remark: "黑色预警：订单已延期", class: 'black', icon: 'exclamation-circle' },
  green: { status: 'green', remark: "绿色预警：订单已交货", class: 'green', icon: 'check-circle', },
}
export default {
  data() {
    return {
      warningStatus: {},
    }
  },
  mounted() {
    if (Boolean(this.propsStatus))
      this.warningStatus = this.propsStatus;
    else
      this.warningStatus = warningStatus;
  },
  computed: {
    status: function () {
      return this.getStatus();
    }
  },
  methods: {
    getStatus() {
      if (Boolean(this.color)) {
        return this.getStatusByColor();
      } else {
        return this.getStatusByTime();
      }
    },
    getStatusByColor() {
      return this.warningStatus[this.color];
    },
    getStatusByTime() {
      if (this.complete) {
        return this.warningStatus[this.completeStatus];
      }
      let time = new Date(this.time).getTime();
      let contrastTime = Boolean(this.contrastTime) ? new Date(this.contrastTime).getTime() : new Date().getTime();
      let sub = time - contrastTime;
      // 正常订单
      let configStatus = Boolean(this.warningStatus[this.configStatus]) ? this.warningStatus[this.configStatus] : {};
      // 对比日期，获取订单状态
      for (let key in this.warningStatus) {
        let status = this.warningStatus[key];
        if (contrastUtils.contrastNum(status, sub)) {
          return status;
        }
      }
      return configStatus;
    },
  },
  props: {
    propsStatus: Object,// 私有的对比状态
    configStatus: { type: String, default: 'colourless' },
    completeStatus: { type: String, default: 'green' },
    contrastTime: String,// 没有则使用now()跟time对比
    time: String,// 对比的时间
    color: String,// 确定使用的颜色
    complete: Boolean,
  },
}
</script>
<style lang="less">
.srm-time-sign {
  font-size: 18px;
  .anticon {
    line-height: normal;
  }
  .red {
    color: #f5222d;
  }
  .gray {
    color: #999;
  }
  .green {
    color: #52c41a;
  }
  .black {
    color: #333;
  }
  .orange {
    color: orange;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/srm-sign/srm-time-sign.vue